<script>
import { componentStore } from '@components/common/componentStore/componentStore.js';

let instanceListConfig = {
    cId: "instanceList",
    cType: "instanceList",
    cTitle: "Instance List",
    showInCmpList: true,
    cTemplate: `<div class="instance-list">
                    <control name="INSTANCE_LIST" :items="instanceList"></control>
                </div>`,
    controls: [
        {
            "name": 'INSTANCE_LIST',
            "type": "dropdown",
            "placeholder": "Select an instance",
            "onchange": "selectInstance",
            "filterBarPlaceholder": "Search here",
            "popupHeight": "220px",
            "allowFiltering": true
        }
    ],
    layoutDatamap: [
        {
            "property": "selectedInstance", "from": "instanceList", "to": "thisStore", "as": "selectedInstance"
        },

    ]
};

let instanceListCmp = {
    name: 'instanceList',
    props: {
        selectedInstance: {
            default: 'dev'
        },
    },
    data() {
        return {
            instanceList: []
        };
    },
    methods: {
        onLoad() {
            configStore.getInstanceList().then(async (data) => {
                if (data) {
                    if (Array.isArray(data)) {
                        data = data.filter(function (item) {
                            return item.toLowerCase() !== 'devdash' && item.toLowerCase() !== 'devdashqa';
                        });
                    }
                    this.instanceList = data;
                    let instance = await configStore.getDevDashLocalInstanceDetails();
                    let tmpInstance = 'dev';
                    if (instance.name) tmpInstance = instance.name;
                    if (Array.isArray(this.instanceList) && this.instanceList.indexOf(tmpInstance) === -1) {
                        tmpInstance = this.instanceList[0];
                    }
                    let getParams = library.urlParser.getParams();
                    if (getParams['instance']) {
                        tmpInstance = getParams['instance'];
                    }
                    this.controls['INSTANCE_LIST'].value = tmpInstance;
                    this.selectInstance({ value: tmpInstance });
                }
            });
        },
        selectInstance: function (item) {
            this.selectedInstance = item.value;
            this.$emit('update:propSelectedInstance', this.selectedInstance);
        }
    }
};

componentStore.initComponent(instanceListCmp, instanceListConfig);
export { instanceListConfig, instanceListCmp };
export default instanceListCmp;
</script>
